import React from 'react';

import fetch from '../fetch';
import utils from '../../utils';


const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'orgName', 
        label: '学院', 
        width: 150, 
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key:'majorName', 
        label: '专业', 
        width: 150, 
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key:'objectName', 
        label: '对象名称', 
        width: 150, 
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key:'targetName', 
        label: '指标名称',
        width: 120,
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key:'subName', 
        label: '所选指标',
        width: 120,
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key: 'auditScore',
        label: '评审分数'
    },
    {
        key:'termName', 
        label: '所属学期'
    }
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    let retResponse;
    const targetId = keywords.targetId;
    if (targetId) {
        retResponse = fetch.post('zgcp/result/analysis/major/sort/expert/list?' + params.join('&'),  Object.assign(defaultsParams, keywords))
    } else {
        retResponse = buildEmptyPromise(keywords.pageNum, keywords.pageSize);
    }
    return retResponse.then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const buildEmptyPromise = (pageNum, pageSize) => {
    return new Promise((resolve, reject) => {
        resolve({
            code: 200,
            payload: {
                data: {
                    dataList: [],
                    pageNum,
                    pageSize,
                    total: 0
                }
            }
        })
    })
}

const getSubListByTargetId = (targetId) => {
    return fetch.get(`zgcp/subitem/get/by/${targetId}`)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}


export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    getSubListByTargetId
}